var _g, _path, _path2, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgB11(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 302,
    height: 535,
    viewBox: "0 0 302 535",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_618_5738)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24.3234,
    cy: 257.322,
    r: 104.673,
    fill: "black"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M111.913 307.587C81.4896 360.282 14.1084 378.337 -38.5868 347.913C-91.2821 317.49 -109.337 250.108 -78.9132 197.413C-48.4896 144.718 18.8916 126.663 71.5868 157.087C124.282 187.51 142.337 254.892 111.913 307.587ZM-60.3175 208.149C-84.8116 250.575 -70.2757 304.823 -27.8506 329.317C14.5745 353.812 68.8233 339.276 93.3175 296.851C117.812 254.425 103.276 200.177 60.8506 175.683C18.4255 151.188 -35.8233 165.724 -60.3175 208.149Z",
    fill: "#264187"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M82.8678 290.797C61.7577 327.361 15.0038 339.889 -21.5599 318.779C-58.1237 297.669 -70.6513 250.915 -49.5412 214.351C-28.4312 177.787 18.3227 165.26 54.8865 186.37C91.4502 207.48 103.978 254.234 82.8678 290.797ZM-36.6382 221.801C-53.634 251.238 -43.548 288.88 -14.1104 305.876C15.3272 322.871 52.9689 312.785 69.9647 283.348C86.9605 253.91 76.8745 216.269 47.4369 199.273C17.9993 182.277 -19.6424 192.363 -36.6382 221.801Z",
    fill: "#1B47B8"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-1_618_5738",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.1916 278.278C47.042 302.785 15.7041 311.182 -8.80358 297.033C-33.3113 282.883 -41.7083 251.545 -27.5587 227.037C-13.4092 202.53 17.9287 194.133 42.4364 208.282C66.9441 222.432 75.3411 253.77 61.1916 278.278ZM-18.9102 232.031C-30.302 251.762 -23.5416 276.992 -3.81033 288.384C15.9209 299.776 41.1512 293.016 52.543 273.284C63.9348 253.553 57.1744 228.323 37.4432 216.931C17.7119 205.539 -7.51832 212.3 -18.9102 232.031Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M61.1916 278.278C47.042 302.785 15.7041 311.182 -8.80358 297.033C-33.3113 282.883 -41.7083 251.545 -27.5587 227.037C-13.4092 202.53 17.9287 194.133 42.4364 208.282C66.9441 222.432 75.3411 253.77 61.1916 278.278ZM-18.9102 232.031C-30.302 251.762 -23.5416 276.992 -3.81033 288.384C15.9209 299.776 41.1512 293.016 52.543 273.284C63.9348 253.553 57.1744 228.323 37.4432 216.931C17.7119 205.539 -7.51832 212.3 -18.9102 232.031Z",
    fill: "#1B47B8",
    stroke: "#FFCC00",
    strokeOpacity: 0.25,
    strokeWidth: 0.750347,
    mask: "url(#path-4-inside-1_618_5738)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_618_5738",
    x: -253.305,
    y: -20.3066,
    width: 555.257,
    height: 555.257,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 86.4775,
    result: "effect1_foregroundBlur_618_5738"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgB11);
export default __webpack_public_path__ + "static/media/b11.04667e0d99c6ecb9cbcca9ddf2460cee.svg";
export { ForwardRef as ReactComponent };